import * as Sentry from '@sentry/react'
import { useAppDispatch } from '../../../store/hooks'
import { addToast } from '../../../store/toast/toastSlice'

export interface BookingLinkActions {
  onCopyLink: () => Promise<void>
  onPushToDraft: () => void
}

export const useBookingLinkActions = (bookingPageSlug?: string): BookingLinkActions => {
  const dispatch = useAppDispatch()

  const onCopyLink = async () => {
    if (!bookingPageSlug) {
      dispatch(addToast({ variant: 'error', title: 'No booking link yet', messages: ['Set up your booking page before sharing a link.'] }))
      return
    }
    try {
      await navigator.clipboard.writeText(`${window.location.origin}/book/${bookingPageSlug}`)
    } catch (error) {
      Sentry.captureException(error)
      dispatch(addToast({ variant: 'error', title: 'Could not copy the link', messages: ['Copy it from your booking page settings instead.'] }))
      return
    }
    dispatch(addToast({ variant: 'success', title: 'Booking link copied', messages: ['Paste it anywhere to share your booking page.'] }))
  }

  const onPushToDraft = () => {
    dispatch(addToast({ variant: 'success', title: 'Pushed to draft', messages: ['Find the invitation in your email drafts to review and send.'] }))
  }

  return { onCopyLink, onPushToDraft }
}
